<!-- eslint-disable -->
<template>
  <div class="d-flex align-items-center justify-content-center" v-if="show">
    <div class="row w-100 mx-0 auth-page">
      <div class="col-md-12 col-xl-12 mx-auto">
        <div class="card">
          <div class="row">
            <div class="col-md-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="noble-ui-logo d-block mb-2">Renouveler<span>&nbsp; Abonnement</span></div>
                  <form @submit.prevent="SubmitData">
                    <div class="row mt-5 mb-5">
                      <div class="col-md-6" v-if="restaurant.serieNumber">
                        <div class="">
                          <input type="text" readonly class="form-control"
                            :value="`Numéro de série : ${restaurant.serieNumber}`" />
                        </div>
                      </div>
                      <div class="col-md-6" v-if="restaurant.LibSite">
                        <div class="">
                          <input type="text" readonly class="form-control"
                            :value="`Nom du restaurant : ${restaurant.LibSite}`" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label">Date début</label>
                          <VueDatePicker locale="fr" v-model="dateDebut"
                            :action-row="{ showSelect: false, showCancel: false }" close-on-scroll auto-apply
                            show-now-button date-picker />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label">Date fin</label>
                          <VueDatePicker locale="fr" v-model="dateFin"
                            :action-row="{ showSelect: false, showCancel: false }" close-on-scroll auto-apply
                            show-now-button date-picker />
                        </div>
                      </div>

                      <div class="col-md-12 mt-3" v-if="jourNumbers?.days">
                        <div class="mb-3">
                          <p v-if="jourNumbers.daysToStart > 0">
                            <b>L'abonnement débutera dans </b> : {{ jourNumbers.daysToStart }} jours
                          </p>
                          <p v-if="jourNumbers.daysToStart <= 0">
                            <b>L'abonnement sera commencer Aujourd'hui </b>
                          </p>
                          <p>
                            <b>Nombre total de jours d'abonnement</b> : {{ jourNumbers.days }} jours
                          </p>
                        </div>
                      </div>
                      <div class="col-md-12 mt-5">
                        <div class="mb-3">
                          <button type="submit" class="btn btn-primary w-100 submit">
                            Enregister
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapActions, mapGetters } from "vuex";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
export default {
  name: "AddrestaurantView",
  components: {
    VueDatePicker
  },
  computed: {
    ...mapGetters({ isRole: "isRole", isAuthenticated: "isAuthenticated", BaseUrl: "StateBase" }),
    jourNumbers() {
      const currentDate = this.$moment()
      var fin = this.$moment(this.dateFin, "MM-DD-YYYY");
      fin = fin.format("YYYY-MM-DD")
      var debut = this.$moment(this.dateDebut, "MM-DD-YYYY");
      debut = debut.format("YYYY-MM-DD")
      const dateDebutToCompare = this.$moment(debut)
      const dateFinToCompare = this.$moment(fin)

      this.newAbn.days = this.$moment(fin).diff(this.$moment(debut), 'days') + 1;
      this.newAbn.days = this.newAbn.days <= 0 ? 0 : this.newAbn.days
      this.newAbn.status = 'actif'
      this.newAbn.daysToStart = 0
      if (dateDebutToCompare.isAfter(currentDate)) {
        this.newAbn.status = 'pending'
        this.newAbn.daysToStart = this.$moment(debut).diff(this.$moment(currentDate), 'days') + 1;
        this.newAbn.daysToStart = this.newAbn.daysToStart <= 0 ? 0 : this.newAbn.daysToStart
      }



      return this.newAbn
    }
  },
  mounted() {
    if (this.$route.params.id) {
      const get = async () => {
        try {
          this.restaurant = await this.getRestaurantById(this.$route.params.id);
          this.id = this.restaurant._id;
          this.name = this.restaurant?.name;
          this.LibSite = this.restaurant?.LibSite;
          this.latestAbonnement = (this.restaurant?.abonnements) ? this.restaurant?.abonnements[this.restaurant?.abonnements.length - 1] : {};

          this.show = true;
        } catch (error) {
          if (error) {
            this.show = false;
            console.log(error);
            //this.showAlert("Forbidden resource");
          }
        }
      };
      if (this.isAuthenticated && this.$store.state.roles.includes(this.isRole))
        get();
    }
  },
  data() {
    return {
      newAbn: {},
      restaurant: null,
      users: [],
      id: "",
      name: "",
      LibSite: "",
      latestAbonnement: {},
      abonnements: [],
      dateDebut: null,
      dateFin: null,
      show: false,
    };
  },
  methods: {
    onChange(event) {
      this.manager = event.target.value;
    },
    showSuccess() {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        icon: "success",
        title: "edit is successfully done",
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
    },
    showAlert(error) {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        icon: "error",
        title: error,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
    },
    ...mapActions(["renouvelerAbonnement", "getRestaurantById"]),
    async SubmitData() {
      this.dateDebut = this.$moment(String(this.dateDebut)).format("MM-DD-YYYY");
      this.dateFin = this.$moment(String(this.dateFin)).format("MM-DD-YYYY");
      const restaurant = {
        id: this.id,
        name: this.name,
        abonnements: { dateDebut: this.dateDebut, dateFin: this.dateFin, motif: '', closed: false }
      };
      try {
        if (
          this.id === "" || this.dateDebut == null || this.dateFin == null
        ) {
          this.showAlert("Veuillez remplir tous les champs");
        } else {
          await this.renouvelerAbonnement(restaurant);
          this.$router.push({
            name: "details-restaurant",
            params: { id: this.id },
          });
        }
      } catch (error) {
        if (error.response.status === 403) {
          this.showAlert("Forbidden");
          return;
        }
        this.showAlert("Il y a un problème, veuillez réessayer s'il vous plaît");
      }
    },
  },
};
</script>
